var FileDescriptionWithMd5 = /** @class */ (function () {
    function FileDescriptionWithMd5(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FileDescriptionWithMd5.prototype.init = function (data) {
        if (data) {
            this.fileName = data["fileName"];
            this.associateId = data["associateId"];
            this.associateType = data["associateType"];
            this.description = data["description"];
            this.md5 = data["md5"];
        }
    };
    FileDescriptionWithMd5.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FileDescriptionWithMd5();
        result.init(data);
        return result;
    };
    FileDescriptionWithMd5.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["associateId"] = this.associateId;
        data["associateType"] = this.associateType;
        data["description"] = this.description;
        data["md5"] = this.md5;
        return data;
    };
    FileDescriptionWithMd5.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FileDescriptionWithMd5();
        result.init(json);
        return result;
    };
    return FileDescriptionWithMd5;
}());
export { FileDescriptionWithMd5 };
